<template>
  <main class="jobs-page">
    <HeroSection />
    <JobsSection />
    <NewsSection
      v-if="articles"
      :articles="articles"
      section-title="Insider knowledge, all in one place for you"
      section-title-md="What's new at Proxify?"
    />
  </main>
</template>

<script>
import HeroSection from './HeroSection/HeroSection.vue';
import JobsSection from './JobsSection/JobsSection.vue';
import NewsSection from '~/components/Common/NewsSection/NewsSection.vue';

export default {
  components: {
    HeroSection,
    JobsSection,
    NewsSection,
  },
  props: {
    articles: {
      type: Array,
      required: true,
    },
  },
  computed: {
    ctaName() {
      return this.$route.params.ctaName || null;
    },
    pageName() {
      return this.$route.params.pageName || null;
    },
    ctaSection() {
      return this.$route.params.ctaSection || null;
    },
  },
  mounted() {
    if (this.ctaName) {
      this.$analytics.track('CTA Clicked', {
        cta_name: this.ctaName,
        page_name: this.pageName,
        section: this.ctaSection,
      });
    }
  },
};
</script>
